module.exports = __webpack_public_path__ + "img/pointer_click.0f5ea1b8.png";